export default __webpack_public_path__ + "static/media/0237.35982b39.jpg";